export const BN_BE_OPTS = {
  isLe: false
};
export const BN_LE_OPTS = {
  isLe: true
};
export const BN_LE_16_OPTS = {
  bitLength: 16,
  isLe: true
};
export const BN_BE_32_OPTS = {
  bitLength: 32,
  isLe: false
};
export const BN_LE_32_OPTS = {
  bitLength: 32,
  isLe: true
};
export const BN_BE_256_OPTS = {
  bitLength: 256,
  isLe: false
};
export const BN_LE_256_OPTS = {
  bitLength: 256,
  isLe: true
};
export const BN_LE_512_OPTS = {
  bitLength: 512,
  isLe: true
};